module.exports = __webpack_public_path__ + "img/brand-3.9e8372dc.png";